<template>
  <div class="airport-dropdown">
    <div class="airport-dropdown__label">Wylot z lotniska</div>
    <div class="airport-dropdown__close">
      <span class="custom-icon--cross calendar-header__icon" @click="close" />
    </div>

    <div class="airport-dropdown__select-all">
      <CheckBox v-model="selected" @input="toggle" />
      <CheckBoxLabel v-model="selected" @input="toggle" :enabled="true" text="Wybierz wszystkie" />
    </div>

    <CheckList ref="list" class="airport-dropdown__body" :value="value" @input="checklistUpdate" />

    <div class="airport-dropdown__footer">
      <div @click="clear" class="airport-dropdown__footer--clear">
        <Icon icon="cross" />Wyczyść
      </div>
      <span @click="close" class="airport-dropdown__footer--select">
        Wybierz
        <Icon class="airport-dropdown__footer__rightarrow" icon="v-right" />
      </span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import AutoCloseMixin from '@/components/AutoCloseMixin'
import CheckBox from '@/components/CheckBox.vue'
import CheckBoxLabel from '@/components/CheckBoxLabel.vue'
import CheckList from '@/components/CheckList.vue'
import Icon from '@/components/Icon.vue'

@Component({
  mixins: [ AutoCloseMixin ],
  components: {
    CheckList,
    CheckBox,
    CheckBoxLabel,
    Icon,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    allSelected: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    enabledCount () {
      return this.value.filter(option => option.enabled).length
    },
    selectedCount () {
      return this.value.filter(option => option.selected).length
    },
  },
})
export default class Airport extends Vue {
  selected = this.allSelected

  mounted () {
    this.$emit('adjustVisibility', this.$el)
  }

  checklistUpdate () {
    this.selected = this.enabledCount === this.selectedCount
    this.$emit('allSelected', this.selected)
  }

  update () {
    this.$emit('update', this.value)
  }

  toggle () {
    if (this.selected) this.$refs.list.selectAll()
    else this.$refs.list.clear()

    this.$emit('allSelected', this.selected)
  }

  clear () {
    this.selected = false
    this.$refs.list.clear()

    this.$emit('allSelected', this.selected)
  }
}
</script>

<style lang="scss" scoped>
.airport-dropdown {
  background-color: #fff;
  position: absolute;
  width: 240px;
  padding: 18px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  border: 1px solid rgba(0, 0, 0, 0.15);
  z-index: 1;
  margin-top: 4px;

  &__label {
    color: #005ca9;
    line-height: 1;
    font-size: 17px;
    font-weight: bold;
  }

  &__close {
    position: absolute;
    right: 0;
    padding: 0 7px;
    top: -3px;
    color: #005ca9;
    cursor: pointer;
    z-index: 1;
  }

  &__select-all {
    display: flex;
    align-items: center;
    margin: 20px 0 17px;
    text-transform: uppercase;

    .checkbox-label {
      font-size: 12px;
      line-height: 1;

      &:hover {
        color: #009fea;
      }
    }
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-transform: uppercase;
    margin-top: 15px;

    &__rightarrow {
      display: flex;
    }

    &--select {
      display: flex;
      align-items: flex-end;
      border: 2px solid #005ca9;
      color: #005ca9;
      background-color: transparent;
      font-weight: bold;
      font-size: 12px;
      padding: 7px 19px;
      font-family: "Gotham";
      cursor: pointer;
      transition: 0.05s all ease-in-out;

      &:hover {
        background-color: #009fea;
        border-color: #009fea;
        color: #fff;
      }

      .figure {
        font-size: 16px;
        line-height: 7px;
      }
    }

    &--clear {
      text-transform: uppercase;
      font-size: 12px;
      margin-right: 20px;
      cursor: pointer;
      line-height: 1;
      padding: 8px 0;
      display: flex;

      &:hover {
        color: #009fea;
      }

      .figure {
        font-size: 8px;
        line-height: 12px;
        margin-right: 6px;
      }
    }
  }
}
</style>

<style lang="scss">
.airport-dropdown {
  .checklist-item {
    padding-bottom: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/fields/AirportDropdown.vue